import { useWalletModal, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
import { Redirect, withRouter } from 'react-router';
import hasWallet from '../../helpers/authServices';

const MyComponent = (props) => {
    const { connection } = useConnection();
    const { wallet, publicKey, sendTransaction } = useWallet();
    const { setVisible } = useWalletModal();
    // console.log(connection, publicKey);
    // const SOL = connection.getAccountInfo().then(res=>{
    //     console.log(res);
    // })

  
if (publicKey) {
    // console.log(publicKey.toBase58());
     localStorage.setItem('wallet', publicKey.toBase58())
}

const { from } = props.location.state || { from: { pathname: '/' }};
  if (hasWallet(localStorage.getItem('wallet'))) {
    return (
      <Redirect to={from} />
    )
  }

    const getBalance = async (publicKey) => {
        // const _publicKey = new PublicKey(publicKey);
    
        const lamports = await connection.getBalance(publicKey).then(res=>{
        // console.log(res.toBuffer());
        })
        .catch((err) => {
          console.error(`Error: ${err}`);
        });
    
        // const sol = lamports / LAMPORTS_PER_SOL;
        return lamports
      };

    //   getBalance(publicKey.toBuffer).then(res=>{
    //     console.log(res);
    //   })


    return (
    	<div>
            <WalletMultiButton />
            

             {/* <button onClick={()=>setVisible(true)}>click</button> */}
        </div>
    )
}

export default withRouter(MyComponent)